import React from "react";
import moment from "moment";
import InfiniteCalendar, { Calendar, withRange } from "react-infinite-calendar";
import "react-infinite-calendar/styles.css";

import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import PageInfo from "./PageInfo";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  list: {
    width: 350
  },
  fullList: {
    width: "auto"
  },
  backdrop: {
    backgroundColor: "transparent"
  },
  button: {
    margin: theme.spacing.unit
  }
});

const colors = {
  queenBlue: "#1d3557",
  spaceCadet: "#457b9d",
  lightBlue: "#a8dadc",
  honeyDew: "#f1faee",
  desire: "#e63946"
};

const theme = {
  accentColor: colors.desire,
  selectionColor: colors.queenBlue,
  textColor: {
    default: colors.queenBlue,
    active: "#FFF"
  },
  todayColor: colors.desire,
  weekdayColor: colors.desire,
  headerColor: colors.queenBlue,
  floatingNav: {
    background: colors.desire,
    color: "#FFF",
    chevron: "#FFA726"
  }
};

// workaround for https://github.com/clauderic/react-infinite-calendar/issues/169
let _dateRange = null;

class DateRangeSelectorDrawer extends React.Component {
  state = {
    isOpen: this.props.isOpen
  }

  render() {
    const { classes, closeDrawer, dateRange } = this.props;
    return (
      <Drawer anchor="left" open={this.props.isOpen} onClose={closeDrawer}>
        <div>
          <InfiniteCalendar
            theme={theme}
            max={new Date()}
            maxDate={new Date()}
            Component={withRange(Calendar)}
            width={600}
            height={600}
            selected={{
              start: dateRange.start,
              end: dateRange.end
            }}
            onSelect={selectedDates => (_dateRange = selectedDates)}
          />
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={() => {
              this.setState({ isOpen: false });
              this.props.closeDrawer(_dateRange);
            }}
          >
            Apply
          </Button>
        </div>
      </Drawer>
    );
  }
}

DateRangeSelectorDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  closeDrawer: PropTypes.func.isRequired
};

export default withStyles(styles)(DateRangeSelectorDrawer);



// WEBPACK FOOTER //
// ./src/components/DateRangeSelectorDrawer.js